import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { Machine } from "./get-machine-by-id";

export interface GetMachinesResponse {
  machines: Machine[];
}

export const getMachines = async (
  namespace: string,
): Promise<GetMachinesResponse> => {
  const url = clientConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();
  try {
    const response = await axios.get<GetMachinesResponse>(
      `${url}/api/v4/ns/${namespace}/machines`,
      { headers },
    );

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      console.error("Axios error:", error);
      throw error;
    }

    throw new Error("An unexpected error occurred while fetching machines.");
  }
};
